<div data-test="cM2mudV9" class="label {{ classes }}">
  <ng-content></ng-content>
  <ng-container *ngIf="closable">
    <i data-test="V0lVcPX1" class="material-icons md-12 ml-1" (click)="handleClose()">
      close
    </i>
  </ng-container>
  <ng-container *ngIf="selectable">
    <i data-test="CLSBIuni" class="material-icons md-12">keyboard_arrow_down</i>
  </ng-container>
</div>
